export const CHAT_MESSAGE_TABLE = "chatMessages"
export const CHAT_MESSAGE_TABLE_SCHEMA =
  "id, sessionId, companyId, position, status, syncId"
